import { useModal } from '@/components/ModalProvider';
import { FileText, X } from 'lucide-react';
import { DialogContent, DialogTitle } from '../../Dialog';

export interface Preview {
  url: string | undefined;
  mime: string | undefined;
}

export interface FilePreviewProps {
  preview: Preview;
  readonly?: boolean;
  onRemove: () => void;
}

export const ShFilePreview: React.FC<FilePreviewProps> = ({
  preview,
  readonly,
  onRemove,
}) => {
  const modal = useModal();

  const isImage = preview.mime?.startsWith('image/');
  const isVideo = preview.mime?.startsWith('video/');

  const onClicked = () => {
    modal.openModal(
      <>
        <DialogTitle></DialogTitle>
        <DialogContent className="mx-auto flex min-w-[95vw] items-center justify-center">
          {isImage && (
            <img
              src={preview.url}
              alt="preview"
              className="max-h-[90vh] max-w-full object-contain"
            />
          )}
          {isVideo && (
            <video
              src={preview.url}
              controls
              className="max-h-[90vh] max-w-full object-contain"
            />
          )}
        </DialogContent>
        ,
      </>,
    );
  };

  return (
    <div className="relative mb-2 w-max">
      {isImage && (
        /* eslint-disable-next-line jsx-a11y/click-events-have-key-events */
        <img
          src={preview.url}
          alt="preview"
          className="max-h-64 rounded-md shadow"
          onClick={onClicked}
        />
      )}

      {isVideo && (
        <video
          src={preview.url}
          controls
          className="max-h-64 rounded-md shadow"
          onClick={onClicked}
        />
      )}

      {!isImage && !isVideo && (
        <div className="flex flex-col items-center">
          <div className="flex h-20 w-40 items-center justify-center rounded-md border border-gray-300 bg-gray-50 shadow">
            <FileText className="h-12 w-12 text-gray-400" />
          </div>
          <a
            href={preview.url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 text-blue-600 underline"
          >
            Download file
          </a>
        </div>
      )}

      {!readonly && (
        <button
          type="button"
          onClick={() => onRemove()}
          aria-label="Remove file"
          className="absolute -top-2 -right-2 rounded-full border border-gray-400 bg-white p-1 shadow hover:bg-gray-100"
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
};
